import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { ShopMode } from '../redux/types';

interface ShopModeDialogProps {
  open: boolean;
  onConfirm: (mode: ShopMode) => void;
  initialMode?: ShopMode;
}

export const ShopModeDialog: React.FC<ShopModeDialogProps> = ({
  open,
  onConfirm,
  initialMode = ShopMode.LocalDelivery,
}) => {
  const [tempMode, setTempMode] = useState(initialMode);

  const handleConfirm = () => {
    onConfirm(tempMode);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>Seleziona modalità di acquisto</DialogTitle>
      <DialogContent>
        <RadioGroup value={tempMode} onChange={(e) => setTempMode(e.target.value as ShopMode)}>
          <FormControlLabel
            value={ShopMode.LocalDelivery}
            control={<Radio color="primary" />}
            label={
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  Consegna diretta
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Ordini nel comune di Mirandola, Carpi e limitrofi con consegna a domicilio in base alla programmazione
                  settimanale.
                </Typography>
              </Box>
            }
            style={{ marginBottom: 16, alignItems: 'flex-start' }}
          />
          <FormControlLabel
            value={ShopMode.DirectSale}
            control={<Radio color="primary" />}
            label={
              <Box>
                <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                  Vendita OnLine
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  Acquisto con pagamento online e spedizione a domicilio con corriere in tutta Italia (isole escluse).
                </Typography>
              </Box>
            }
            style={{ alignItems: 'flex-start' }}
          />
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
};
